import { useMemo, useState } from "react";
import { archives } from "@/mocks/gossip";
import { archiveImages } from "@/mocks/editorialImages";
import Reveal from "./Reveal";
import ArchiveCard from "./ArchiveCard";

const cats = [
  { key: "全部", label: "全部档案" },
  { key: "娱乐圈", label: "娱乐圈" },
  { key: "网络热点", label: "网络热点" },
  { key: "商业圈", label: "商业圈" },
  { key: "社会议题", label: "社会议题" },
];

export default function ArchiveSection() {
  const [cat, setCat] = useState("全部");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    let list = cat === "全部" ? archives : archives.filter((a) => a.cat === cat);
    if (keyword.trim()) {
      const kw = keyword.trim().toLowerCase();
      list = list.filter(
        (a) =>
          a.title.toLowerCase().includes(kw) ||
          a.lead.toLowerCase().includes(kw) ||
          a.tags.some((t) => t.toLowerCase().includes(kw))
      );
    }
    return list;
  }, [cat, keyword]);

  return (
    <section id="archive" className="bg-background-50 py-16 md:py-24">
      <div className="section-wrap">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
                <span className="h-px w-6 bg-primary-600"></span> EVENT ARCHIVES
              </p>
              <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950 md:text-4xl">
                事件档案库 · 来龙去脉全记录
              </h2>
              <p className="mt-3 max-w-2xl text-foreground-600">
                点击事件卡片展开完整时间线，从起因到进展，一网打尽，看懂背后门道。
              </p>
            </div>
            {/* search */}
            <div className="flex w-full max-w-sm items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2.5 focus-within:border-primary-400">
              <i className="ri-search-line text-lg text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索事件 / 关键词 / 标签…"
                aria-label="搜索事件档案"
                className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
              {keyword && (
                <button
                  onClick={() => setKeyword("")}
                  aria-label="清空搜索"
                  className="text-foreground-400 hover:text-primary-600"
                >
                  <i className="ri-close-circle-fill text-lg"></i>
                </button>
              )}
            </div>
          </div>
        </Reveal>

        {/* category tabs */}
        <Reveal delay={50}>
          <div className="mt-8 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button
                key={c.key}
                onClick={() => setCat(c.key)}
                className={`whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
                  cat === c.key
                    ? "bg-primary-600 font-medium text-white"
                    : "border border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </Reveal>

        {/* grid */}
        {filtered.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
            {filtered.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 60}>
                <ArchiveCard archive={a} img={archiveImages[a.imgSeq].img} alt={archiveImages[a.imgSeq].alt} />
              </Reveal>
            ))}
          </div>
        ) : (
          <div className="mt-10 rounded-2xl border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-file-search-line text-5xl text-foreground-300"></i>
            <p className="mt-4 text-foreground-600">没有找到匹配的档案，换个关键词试试吧</p>
            <button
              onClick={() => {
                setKeyword("");
                setCat("全部");
              }}
              className="mt-5 rounded-full bg-primary-600 px-6 py-2.5 text-sm font-medium text-white"
            >
              重置筛选
            </button>
          </div>
        )}
      </div>
    </section>
  );
}